import { render, staticRenderFns } from "./shortCodes.vue?vue&type=template&id=5beb48a7&"
import script from "./shortCodes.vue?vue&type=script&lang=js&"
export * from "./shortCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports